import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import Checkout from "./Checkout";

const CheckoutWrapper = ({ stripePromise }) => {
  const { planId, clientSecret } = useParams();

  const PLAN_CODES = useMemo(
    () => ({
      aJ3d8Lk29vX4: "Pro",        // Monthly
      N9sJ0qWz7eB1: "Pro_Annual", // Annual
    }),
    []
  );

  const planKey = PLAN_CODES[planId] || "Pro"; // fallback

  const options = useMemo(
    () => ({
      clientSecret,
      appearance: { theme: "stripe" },
    }),
    [clientSecret]
  );

  return (
    <Elements stripe={stripePromise} options={options}>
      <Checkout planKey={planKey} />
    </Elements>
  );
};

export default CheckoutWrapper;
